import React from 'react';
import { Bell, QuestionCircle } from 'react-bootstrap-icons';
import Login from '../../components/Login';
import backgroundDesktop from '../../assets/img/background.png';
import backgroundMobile from '../../assets/img/background-mobile-enterprise.png';
import logo from '../../assets/img/logo.png';

import './style.css';

function Index() {
    return (
        <main
            className="enterprise-login-page"
            style={{
                '--login-bg-desktop': `url(${backgroundDesktop})`,
                '--login-bg-mobile': `url(${backgroundMobile})`
            }}
        >
            <header className="enterprise-topbar">
                <a className="enterprise-government-brand" href="/" aria-label="Beranda Kota Padang Blended Learning">
                    <img src={logo} alt="Lambang Kota Padang" />
                    <span>
                        <strong>PEMERINTAH KOTA PADANG</strong>
                        <small>Portal Pendidikan Digital</small>
                    </span>
                </a>

                <nav className="enterprise-topbar-actions" aria-label="Navigasi bantuan">
                    <a href="/forgot" className="enterprise-help-link">
                        <QuestionCircle aria-hidden="true" />
                        <span>Bantuan</span>
                    </a>
                    <a href="/skl/" className="enterprise-graduation-link">
                        <Bell aria-hidden="true" />
                        <span>Pengumuman kelulusan</span>
                    </a>
                </nav>
            </header>

            <div className="enterprise-login-content">
                <section className="enterprise-hero-copy" aria-labelledby="enterprise-hero-title">
                    <span className="enterprise-eyebrow">KOTA PADANG BLENDED LEARNING</span>
                    <h1 id="enterprise-hero-title">Satu portal untuk pembelajaran yang lebih terhubung.</h1>
                    <p>Belajar, mengajar, dan berkolaborasi dalam satu ekosistem pendidikan digital.</p>
                </section>

                <section className="enterprise-auth-shell" aria-label="Form masuk">
                    <Login variant="enterprise" />
                </section>
            </div>
        </main>
    );
}

export default Index;
